import { render, staticRenderFns } from "./SearchCatalogToIncludeProduct.vue?vue&type=template&id=5fd0ba56&scoped=true&"
import script from "./SearchCatalogToIncludeProduct.vue?vue&type=script&lang=js&"
export * from "./SearchCatalogToIncludeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0ba56",
  null
  
)

export default component.exports